const styles = () => ({
  instanceButtonItemContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    maxWidth: '112px',
  },
  popoutIcon: {
    height: '35px',
    width: '35px',
    fontSize: '2.5em',
    padding: '5px',
    borderRadius: '50%',
    boxShadow:
      '0px 2px 3px 0px rgba(0,0,0,0.2), 0px 3px 2px 0px rgba(0,0,0,0.14), 0px 3px 2px -1px rgba(0,0,0,0.12)',
    color: 'white',
    background: '#4f0043',
    '&[disabled]': {
      background: 'rgba(77, 0, 66, 0.26)',
    },
  },
  popoutIconContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  popoutIconLabel: {
    paddingTop: '0.75em',
    width: '100%',
    textTransform: 'none',
    fontSize: '.785714rem',
  },
  actionButton: {
    '&:hover': {
      background: 'none',
    },
  },
  zeroPadding: {
    padding: '0',
  },
  tooltip: {
    marginTop: -25,
    marginLeft: 25,
  },
});

export default styles;
